import { CommonModule } from '@angular/common'
import { Component, input, output } from '@angular/core'
import { ProfilePicComponent } from '../../../../components/profile-pic/profile-pic.component'
import { InternationalizationService } from '../../../../services/internationalization.service'
import { ChatEntity } from '../../interfaces/chat.interface'
import { MessageChatStateService } from '../../services/message-chat-state.service'

@Component({
  selector: 'app-chat-header',
  standalone: true,
  imports: [CommonModule, ProfilePicComponent],
  templateUrl: './chat-header.component.html',
  styleUrl: './chat-header.component.scss',
})
export class ChatHeaderComponent {
  readonly chat = input.required<ChatEntity>()
  readonly groupInfoClicked = output<void>()
  readonly editGroupClicked = output<void>()

  constructor(
    protected state: MessageChatStateService,
    protected translateService: InternationalizationService
  ) {}

  get displayName(): string {
    const c = this.chat()
    if (c.type === 'PRIVATE') {
      const other = c.participants?.find((p) => p.userId !== this.state.currentUserId())
      return other?.userName ?? c.name
    }
    return c.name
  }

  get isOnline(): boolean {
    const c = this.chat()
    if (c.type !== 'PRIVATE') {
      return false
    }
    const other = c.participants?.find((p) => p.userId !== this.state.currentUserId())
    return other ? this.state.onlineUserIds().has(other.userId) : false
  }

  get participantsSummary(): string {
    const c = this.chat()
    if (c.type !== 'GROUP' || !c.participants?.length) {
      return ''
    }
    const names = c.participants
      .slice(0, 3)
      .map((p) =>
        p.userId === this.state.currentUserId()
          ? this.translateService.getTranslation(4162)
          : p.userName.split(' ')[0]
      )
    if (c.participants.length > 3) {
      names.push(this.translateService.getTranslation(2144))
    }
    return names.join(', ')
  }

  onGroupNameClick(): void {
    if (this.chat().type === 'GROUP') {
      this.groupInfoClicked.emit()
    }
  }
}
